/** Domain must end with a TLD of at least 2 letters (no trailing dot). */
export const EMAIL_REGEX = /^[^\s@]+@([^\s@]+\.)+[a-zA-Z]{2,}$/

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.trim())
}
